<template>
  <div></div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'PicaServiceRedirect',
  computed: {
    ...mapGetters('event', ['isDraft', 'isEdge']),
    ...mapGetters('login', ['hasPerms']),
  },
  async mounted() {
    // Aspetta che EventManager finisca il loading
    let attempts = 0
    while (this.$parent?.loading && attempts < 100) {
      await new Promise(resolve => setTimeout(resolve, 50))
      attempts++
    }

    const picaServiceId = parseInt(this.$route.params.picaServiceId)

    // Priority 1: If event is draft, go to event profile
    if (this.isDraft) {
      await this.$router.replace({
        name: 'eventWizard.date_and_name',
        params: {picaServiceId}
      })
      return
    }

    if (this.isEdge) {
      // Priority 2: Edge Prints List
      if (this.hasPerms(['event_wizard.see_printer'])) {
        await this.$router.replace({
          name: 'edgePrintOrderList',
          params: {picaServiceId}
        })
        return
      }

      // Priority 3: Edge Orders List
      if (this.hasPerms(['event_wizard.see_orders'])) {
        await this.$router.replace({
          name: 'edgeOrderList',
          params: {picaServiceId}
        })
        return
      }
    }


    // Priority 4: Overview (default fallback)
    await this.$router.replace({
      name: 'eventWizard.overview',
      params: {picaServiceId}
    })
  }
}
</script>
